<!-- News Letter Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">News Letter Management</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
        <!-- Search -->
        <div class="d-flex align-items-center position-relative me-3">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input type="text" class="form-control form-control-sm w-250px ps-10" placeholder="Search news letters..."
            [(ngModel)]="searchTerm" (keyup.enter)="applyFilters()" />
        </div>

        <!-- Add News Letter Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddNewsLetterModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add News Letter
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- News Letters Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-150px">Title</th>
            <th class="min-w-150px">Models</th>
            <th class="min-w-150px">Makes</th>
            <th class="min-w-120px">Countries</th>
            <th class="min-w-100px">News Letter</th>
            <th class="min-w-120px">Audience</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="7" class="text-center py-5">
              <div class="d-flex justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading news letters...
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="!isLoading && newsLetters.length === 0">
            <td colspan="7" class="text-center py-5">
              <div class="text-gray-600">No news letters found</div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let newsLetter of newsLetters; trackBy: trackByFn">
            <td>
              <span class="text-dark fw-semibold d-block fs-7">{{ newsLetter.title || '-' }}</span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ newsLetter.models?.length ? newsLetter.models.join(', ') : '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ newsLetter.makes?.length ? newsLetter.makes.join(', ') : '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ newsLetter.countries?.length ? newsLetter.countries.join(', ') : '-' }}
              </span>
            </td>
            <td>
              <span class="badge"
                [ngClass]="newsLetter.news_letter === 'send_newsletter' ? 'badge-light-success' : 'badge-light-primary'">
                {{ newsLetter.news_letter === 'send_newsletter' ? 'Send Newsletter' : 'Save' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">{{ getAudienceLabels(newsLetter.audience) }}</span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button type="button" class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditNewsLetterModal(newsLetter)" title="Edit News Letter">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button type="button" class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteNewsLetter(newsLetter)" title="Delete News Letter">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && newsLetters.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Include the add-edit modal -->
<app-add-edit-news-letter (newsLetterAdded)="onNewsLetterAdded()"
  (newsLetterUpdated)="onNewsLetterUpdated()"></app-add-edit-news-letter>
